module.exports = __webpack_public_path__ + "img/thumbnail_Cheetah_f_albino.b6497332.png";